import {
  CancelableQueryViewArgs,
  query,
  Query,
  QueryHandlerFunction,
  QueryHandlerFunctionArgs,
} from "@lookiero/messaging";
import { NextBestActionDefinitionProjection } from "./nextBestActionDefinition";

const VIEW_STYLE_PROFILE_NEXT_BEST_ACTION_DEFINITION_BY_CUSTOMER_ID =
  "view_style_profile_next_best_action_definition_by_customer_id";

interface ViewStyleProfileNextBestActionDefinitionByCustomerIdPayload {
  readonly customerId: string;
}

interface ViewStyleProfileNextBestActionDefinitionByCustomerId
  extends
    Query<typeof VIEW_STYLE_PROFILE_NEXT_BEST_ACTION_DEFINITION_BY_CUSTOMER_ID>,
    ViewStyleProfileNextBestActionDefinitionByCustomerIdPayload {}

interface ViewStyleProfileNextBestActionDefinitionByCustomerIdFunction {
  (
    payload: ViewStyleProfileNextBestActionDefinitionByCustomerIdPayload,
  ): ViewStyleProfileNextBestActionDefinitionByCustomerId;
}

const viewStyleProfileNextBestActionDefinitionByCustomerId: ViewStyleProfileNextBestActionDefinitionByCustomerIdFunction =
  (payload) => ({
    ...query({ name: VIEW_STYLE_PROFILE_NEXT_BEST_ACTION_DEFINITION_BY_CUSTOMER_ID }),
    ...payload,
  });

type ViewStyleProfileNextBestActionDefinitionByCustomerIdResult = NextBestActionDefinitionProjection | null;

interface StyleProfileNextBestActionDefinitionByCustomerIdViewArgs extends CancelableQueryViewArgs {
  readonly customerId: string;
}

interface StyleProfileNextBestActionDefinitionByCustomerIdView {
  (
    args: StyleProfileNextBestActionDefinitionByCustomerIdViewArgs,
  ): Promise<ViewStyleProfileNextBestActionDefinitionByCustomerIdResult>;
}

interface ViewStyleProfileNextBestActionDefinitionByCustomerIdHandlerFunctionArgs extends QueryHandlerFunctionArgs {
  readonly view: StyleProfileNextBestActionDefinitionByCustomerIdView;
}

const viewStyleProfileNextBestActionDefinitionByCustomerIdHandler: QueryHandlerFunction<
  ViewStyleProfileNextBestActionDefinitionByCustomerId,
  ViewStyleProfileNextBestActionDefinitionByCustomerIdResult,
  ViewStyleProfileNextBestActionDefinitionByCustomerIdHandlerFunctionArgs
> =
  ({ view, signal }) =>
  async ({ customerId }) =>
    view({ customerId, signal });

export type {
  StyleProfileNextBestActionDefinitionByCustomerIdView,
  ViewStyleProfileNextBestActionDefinitionByCustomerIdResult,
};
export {
  VIEW_STYLE_PROFILE_NEXT_BEST_ACTION_DEFINITION_BY_CUSTOMER_ID,
  viewStyleProfileNextBestActionDefinitionByCustomerId,
  viewStyleProfileNextBestActionDefinitionByCustomerIdHandler,
};
